// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/impression.proto" (package "bianka.event.activity.v2", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Organization } from "../../../core/enrichment/organization";
import { User } from "../../../core/enrichment/user";
import { Order } from "../../../core/enrichment/order";
import { Gig } from "../../../core/enrichment/gig";
import { Page } from "../../../common/activity/v1/page";
/**
 * Next serial number to be used: 13
 *
 * @generated from protobuf message bianka.event.activity.v2.Impression
 */
export interface Impression {
    /**
     * The type of the impression
     *
     * @generated from protobuf field: string type = 2
     */
    type: string;
    /**
     * Data regarding the impressioned component
     *
     * @generated from protobuf field: bianka.event.activity.v2.Impression.Component component = 3
     */
    component?: Impression_Component;
    /**
     * The page the impression was made on
     *
     * @generated from protobuf field: bianka.common.activity.v1.Page page = 11
     */
    page?: Page;
    /**
     * Enrichments
     *
     * @generated from protobuf field: bianka.core.enrichment.Gig gig = 6
     */
    gig?: Gig;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Order order = 7
     */
    order?: Order;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User user = 8
     */
    user?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User buyer = 9
     */
    buyer?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User seller = 10
     */
    seller?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Organization organization = 12
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.Impression.Component
 */
export interface Impression_Component {
    /**
     * The component's impression id
     *
     * @generated from protobuf field: string imp_id = 1
     */
    impId: string;
    /**
     * The parent component's impression id
     *
     * @generated from protobuf field: optional string parent_component_imp_id = 2
     */
    parentComponentImpId?: string;
    /**
     * The name of the component
     *
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * The level of the component in the page
     *
     * @generated from protobuf field: int32 level = 4
     */
    level: number;
    /**
     * Indicates the component is a leaf component
     *
     * @generated from protobuf field: bool is_leaf = 5
     */
    isLeaf: boolean;
    /**
     * The position of the component in the parent component (or in the root page)
     *
     * @generated from protobuf field: int32 position_in_parent = 6
     */
    positionInParent: number;
    /**
     * The component size percentage from the parent component
     *
     * @generated from protobuf field: double size_in_parent = 7
     */
    sizeInParent: number;
    /**
     * Whether the component was visible at first or scroll was needed in order to observe it
     * False - component wasn't visible through scroll, meaning it was visible to begin with
     * True - component was visible through scroll, it wasn't visible to begin with
     *
     * @generated from protobuf field: bool visible_through_scroll = 8
     */
    visibleThroughScroll: boolean;
    /**
     * Attributes related to component's location on the screen
     *
     * @generated from protobuf field: bianka.event.activity.v2.Impression.Component.Location location = 9
     */
    location?: Impression_Component_Location;
    /**
     * The type of the component - extra indicator on top of component's name
     *
     * @generated from protobuf field: optional string type = 10
     */
    type?: string;
    /**
     * Component's text value
     *
     * @generated from protobuf field: optional string text = 11
     */
    text?: string;
    /**
     * The number of elements in the component
     *
     * @generated from protobuf field: optional int32 number_of_elements = 12
     */
    numberOfElements?: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.Impression.Component.Location
 */
export interface Impression_Component_Location {
    /**
     * Component's first pixel y axis on the screen (used to assess components that share a row)
     *
     * @generated from protobuf field: int32 top_y_axis = 1
     */
    topYAxis: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class Impression$Type extends MessageType<Impression> {
    constructor() {
        super("bianka.event.activity.v2.Impression", [
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "bianka.core.extension.required": true } },
            { no: 3, name: "component", kind: "message", T: () => Impression_Component },
            { no: 11, name: "page", kind: "message", T: () => Page },
            { no: 6, name: "gig", kind: "message", T: () => Gig },
            { no: 7, name: "order", kind: "message", T: () => Order },
            { no: 8, name: "user", kind: "message", T: () => User },
            { no: 9, name: "buyer", kind: "message", T: () => User },
            { no: 10, name: "seller", kind: "message", T: () => User },
            { no: 12, name: "organization", kind: "message", T: () => Organization }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
    create(value?: PartialMessage<Impression>): Impression {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<Impression>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Impression): Impression {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* bianka.event.activity.v2.Impression.Component component */ 3:
                    message.component = Impression_Component.internalBinaryRead(reader, reader.uint32(), options, message.component);
                    break;
                case /* bianka.common.activity.v1.Page page */ 11:
                    message.page = Page.internalBinaryRead(reader, reader.uint32(), options, message.page);
                    break;
                case /* bianka.core.enrichment.Gig gig */ 6:
                    message.gig = Gig.internalBinaryRead(reader, reader.uint32(), options, message.gig);
                    break;
                case /* bianka.core.enrichment.Order order */ 7:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                case /* bianka.core.enrichment.User user */ 8:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* bianka.core.enrichment.User buyer */ 9:
                    message.buyer = User.internalBinaryRead(reader, reader.uint32(), options, message.buyer);
                    break;
                case /* bianka.core.enrichment.User seller */ 10:
                    message.seller = User.internalBinaryRead(reader, reader.uint32(), options, message.seller);
                    break;
                case /* bianka.core.enrichment.Organization organization */ 12:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Impression, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* bianka.event.activity.v2.Impression.Component component = 3; */
        if (message.component)
            Impression_Component.internalBinaryWrite(message.component, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.Gig gig = 6; */
        if (message.gig)
            Gig.internalBinaryWrite(message.gig, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.Order order = 7; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.User user = 8; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.User buyer = 9; */
        if (message.buyer)
            User.internalBinaryWrite(message.buyer, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.User seller = 10; */
        if (message.seller)
            User.internalBinaryWrite(message.seller, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* bianka.common.activity.v1.Page page = 11; */
        if (message.page)
            Page.internalBinaryWrite(message.page, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.Organization organization = 12; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.Impression
 */
export const Impression = new Impression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Impression_Component$Type extends MessageType<Impression_Component> {
    constructor() {
        super("bianka.event.activity.v2.Impression.Component", [
            { no: 1, name: "imp_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent_component_imp_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_leaf", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "position_in_parent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "size_in_parent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "visible_through_scroll", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "location", kind: "message", T: () => Impression_Component_Location },
            { no: 10, name: "type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "text", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "number_of_elements", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Impression_Component>): Impression_Component {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.impId = "";
        message.name = "";
        message.level = 0;
        message.isLeaf = false;
        message.positionInParent = 0;
        message.sizeInParent = 0;
        message.visibleThroughScroll = false;
        if (value !== undefined)
            reflectionMergePartial<Impression_Component>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Impression_Component): Impression_Component {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string imp_id */ 1:
                    message.impId = reader.string();
                    break;
                case /* optional string parent_component_imp_id */ 2:
                    message.parentComponentImpId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* int32 level */ 4:
                    message.level = reader.int32();
                    break;
                case /* bool is_leaf */ 5:
                    message.isLeaf = reader.bool();
                    break;
                case /* int32 position_in_parent */ 6:
                    message.positionInParent = reader.int32();
                    break;
                case /* double size_in_parent */ 7:
                    message.sizeInParent = reader.double();
                    break;
                case /* bool visible_through_scroll */ 8:
                    message.visibleThroughScroll = reader.bool();
                    break;
                case /* bianka.event.activity.v2.Impression.Component.Location location */ 9:
                    message.location = Impression_Component_Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* optional string type */ 10:
                    message.type = reader.string();
                    break;
                case /* optional string text */ 11:
                    message.text = reader.string();
                    break;
                case /* optional int32 number_of_elements */ 12:
                    message.numberOfElements = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Impression_Component, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string imp_id = 1; */
        if (message.impId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.impId);
        /* optional string parent_component_imp_id = 2; */
        if (message.parentComponentImpId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.parentComponentImpId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* int32 level = 4; */
        if (message.level !== 0)
            writer.tag(4, WireType.Varint).int32(message.level);
        /* bool is_leaf = 5; */
        if (message.isLeaf !== false)
            writer.tag(5, WireType.Varint).bool(message.isLeaf);
        /* int32 position_in_parent = 6; */
        if (message.positionInParent !== 0)
            writer.tag(6, WireType.Varint).int32(message.positionInParent);
        /* double size_in_parent = 7; */
        if (message.sizeInParent !== 0)
            writer.tag(7, WireType.Bit64).double(message.sizeInParent);
        /* bool visible_through_scroll = 8; */
        if (message.visibleThroughScroll !== false)
            writer.tag(8, WireType.Varint).bool(message.visibleThroughScroll);
        /* bianka.event.activity.v2.Impression.Component.Location location = 9; */
        if (message.location)
            Impression_Component_Location.internalBinaryWrite(message.location, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional string type = 10; */
        if (message.type !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.type);
        /* optional string text = 11; */
        if (message.text !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.text);
        /* optional int32 number_of_elements = 12; */
        if (message.numberOfElements !== undefined)
            writer.tag(12, WireType.Varint).int32(message.numberOfElements);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.Impression.Component
 */
export const Impression_Component = new Impression_Component$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Impression_Component_Location$Type extends MessageType<Impression_Component_Location> {
    constructor() {
        super("bianka.event.activity.v2.Impression.Component.Location", [
            { no: 1, name: "top_y_axis", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Impression_Component_Location>): Impression_Component_Location {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.topYAxis = 0;
        if (value !== undefined)
            reflectionMergePartial<Impression_Component_Location>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Impression_Component_Location): Impression_Component_Location {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 top_y_axis */ 1:
                    message.topYAxis = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Impression_Component_Location, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 top_y_axis = 1; */
        if (message.topYAxis !== 0)
            writer.tag(1, WireType.Varint).int32(message.topYAxis);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.Impression.Component.Location
 */
export const Impression_Component_Location = new Impression_Component_Location$Type();
